import { red } from "@mui/material/colors";

const styles = {
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    height: "100%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  title: {
    fontWeight: "bold",
  },
  buttonsContainer: {
    display: "flex",
    gap: "12px",
    padding: "0px !important",
  },
  activeButton: {
    borderRadius: "0.5rem",
    height: "38px",
    color: red["A400"],
    backgroundColor: red["50"],
    padding: "10px 20px",
    "&:hover": {
      backgroundColor: red["100"],
    },
  },
};

export default styles;

